import { render, staticRenderFns } from "./SelectCompany.vue?vue&type=template&id=4b2edf26&scoped=true&"
import script from "./SelectCompany.vue?vue&type=script&lang=ts&"
export * from "./SelectCompany.vue?vue&type=script&lang=ts&"
import style0 from "./SelectCompany.vue?vue&type=style&index=0&id=4b2edf26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2edf26",
  null
  
)

export default component.exports